/* tslint:disable:jsx-no-lambda WI:47724 */
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';
import SearchInlineFeedback from './SearchInlineFeedback';
import SearchInContextFeedbackDialog from './SearchInContextFeedbackDialog';

// User Voice teams using this component
export enum UserVoiceSearchTeam {
    MailSearch,
    CalendarSearch,
}

export interface SearchInContextFeedbackProps {
    cssClass: string;
    currentSearchQueryId: string;
    userVoiceTeam: UserVoiceSearchTeam;
}

const SearchInContextFeedback = observer(function SearchInContextFeedback(
    props: SearchInContextFeedbackProps
) {
    return (
        <>
            {isFeatureEnabled('sea-inlineFeedback') && (
                <SearchInlineFeedback
                    cssClass={props.cssClass}
                    currentSearchQueryId={props.currentSearchQueryId}
                    userVoiceTeam={props.userVoiceTeam}
                />
            )}

            {!isFeatureEnabled('sea-inlineFeedback') && (
                <SearchInContextFeedbackDialog
                    cssClass={props.cssClass}
                    currentSearchQueryId={props.currentSearchQueryId}
                    userVoiceTeam={props.userVoiceTeam}
                />
            )}
        </>
    );
});

export default SearchInContextFeedback;
